<template>
  <div>
    <filtro-cadu v-model="valueData" @limparFiltro="limparFiltro()" @filtrar="filtrar()">
      <div slot="body" class="mx-5" style="height: 420px">
        <v-row>
          <v-col cols="auto">
            <div class="fontColor1--text font-weight-bold">
              FILTRAR HIERARQUIA
            </div>
          </v-col>
        </v-row>

        <ValidationObserver ref="observer">
          <v-row>
            <v-col cols="12">
              <autocomplete-cadu
                placeholder
                title="Unimed"
                v-model="dadoUnimed"
                @index="getIdUnimed"
                onlyAlphaNum
                :items="listarUnimeds.map((el) => el.textoExibicao)"
                :max="'150'"
              />
            </v-col>
            <v-col cols="12">
              <autocomplete-cadu
                placeholder
                title="Hierarquia"
                v-model="dadoUnimedHierarquia"
                @index="getIdHierarquia"
                onlyAlphaNum
                :items="listarUnimedsHierarquia.map((el) => el.textoExibicao)"
                :max="'150'"
              />
            </v-col>
          </v-row>
        </ValidationObserver>
      </div>
    </filtro-cadu>
    <error-modal
      v-model="error"
      :errObj="errObj"
    />
  </div>
</template>

<script>
/* eslint-disable */

import { ValidationProvider, ValidationObserver } from "vee-validate";
import ListarUnimeds from '@/services/Unimed/ListarUnimed'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      valueData: this.value,
      dadoUnimed: '',
      dadoUnimedHierarquia: '',
      tokenBearer: localStorage.getItem('tokenBearer'),
      error: false,
      errObj: {},
      listarUnimeds: [],
      listarUnimedsHierarquia: [],
      idHierarquia: '',
      idUnimed: ''
    };
  },
  beforeMount () {
    this.getAllUnimeds(),
    this.getUnimedsHierarquia()
  },
  methods: {
    getIdUnimed (index) {
      this.idUnimed = (index !== null && index > -1) ? this.listarUnimeds[index].id : ''
    },
    getIdHierarquia (index) {
      this.idHierarquia = (index !== null && index > -1) ? this.listarUnimedsHierarquia[index].id : ''
    },
    async getAllUnimeds () {
      const listar = new ListarUnimeds(this.tokenBearer, this.$appConfig.config.API)

      try {
        const response = await listar.getAll()
        
        this.listarUnimeds = response.data
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async getUnimedsHierarquia () {
      const listar = new ListarUnimeds(this.tokenBearer, this.$appConfig.config.API)

      try {
        const response = await listar.getConfederacaoAndFederacao()
        
        this.listarUnimedsHierarquia = response.data
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    limparFiltro() {
      this.dadoUnimed = ''
      this.dadoUnimedHierarquia = ''
      this.idHierarquia = ''
      this.idUnimed = ''
    },
    filtrar() {
      let filtro = {
          idUnimed: this.idUnimed,
          idHierarquia: this.idHierarquia
      };

      this.$emit("filtrar-hierarquia", filtro);
      this.valueData = false;
    }
  },
  watch: {
    valueData() {
      if (!this.valueData) {
        this.$emit("input", false);
      }
    },
    value() {
      this.valueData = this.value;
    }
  }
};
</script>